export const ADMIN_LOG_ACTOR_SCOPES = Object.freeze({
  All: "all",
  External: "external",
  Internal: "internal",
});

export function normalizeAdminLogActorScope(value) {
  const normalized = String(value ?? "").trim().toLowerCase();

  if (normalized === ADMIN_LOG_ACTOR_SCOPES.External) {
    return ADMIN_LOG_ACTOR_SCOPES.External;
  }

  if (normalized === ADMIN_LOG_ACTOR_SCOPES.Internal) {
    return ADMIN_LOG_ACTOR_SCOPES.Internal;
  }

  return ADMIN_LOG_ACTOR_SCOPES.All;
}
